import { type RefObject, useEffect } from 'react';

import {
	getInputSkeletonFocus,
	getInputSkeletonQuery,
	getInputSkeletonSelection,
	removeInputSkeletonState,
} from '@atlassian/search-dialog/query-store';

// The query is stored in module scope to persist across remounts
let initialQueryValue: string | undefined;

export const getInitialQuery = (searchQueryParams?: string): string => {
	const stickySearch = initialQueryValue;

	return searchQueryParams || stickySearch || getInputSkeletonQuery() || '';
};

export type InputSkeletonProps = {
	localQuery: string;
	inputRef?: RefObject<HTMLInputElement>;
};

export const useInputSkeleton = ({ localQuery, inputRef }: InputSkeletonProps): void => {
	// Focus input if skeleton is focused
	useEffect(() => {
		const skeletonFocused = getInputSkeletonFocus();

		if (skeletonFocused) {
			const input = inputRef?.current;
			if (input) {
				input.focus();
				input.click();
				const { selectionStart, selectionEnd, selectionDirection } = getInputSkeletonSelection();
				input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
			}
		}

		removeInputSkeletonState();
	}, [inputRef]);

	// Push local query to session storage
	useEffect(() => {
		// Update the module-scoped variable to make it available for remounts
		initialQueryValue = localQuery;
	}, [localQuery]);
};
